import { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { useUserStore } from '@/store';

export default function usePermission() {
  const userStore = useUserStore();
  return {
    accessRouter(route: RouteLocationNormalized | RouteRecordRaw) {
      return (
        !route.meta?.requiresAuth ||
        !route.meta?.roles ||
        route.meta?.roles?.includes('*') ||
        route.meta?.roles?.includes(userStore.role)
      );
    },
    findFirstPermissionRoute(_routers: any, role = 'admin') {
      const findRoute = (routers: any): any => {
        const cloneRouters = [...routers];
        while (cloneRouters.length) {
          const firstElement = cloneRouters.shift();
          // Check if route has no roles restriction or allows current role
          if (
            !firstElement?.meta?.roles ||
            firstElement.meta.roles.includes('*') ||
            firstElement.meta.roles.includes(role)
          ) {
            // If it's a leaf node or has accessible children, return it
            if (!firstElement.children || firstElement.children.length === 0) {
              return { name: firstElement.name };
            }
            // If it has children, check if any child is accessible
            const accessibleChild = findRoute(firstElement.children);
            if (accessibleChild) {
              return accessibleChild;
            }
          }
          if (firstElement?.children) {
            cloneRouters.push(...firstElement.children);
          }
        }
        return null;
      };
      return findRoute(_routers);
    },
    // You can add any rules you want
  };
}
